// extracted by mini-css-extract-plugin
export default {"deleted":"solace-queue_deleted__9VhGm"};